<div class="support-wrapper">
  <app-toolbar />
  <section
    class="feature-shell overlay-scroll--custom"
    data-testid="support-center-page"
    scrollActivity
    [scrollActivityCustom]="true"
  >
    <div class="intro-section">
      <h1 data-testid="support-center-heading">Support &amp; Resources</h1>
      <p data-testid="support-center-intro-text">
        Welcome to the BCR Support Center. Use the resources below to access documentation and
        contact support or process owners.
      </p>
    </div>

    <div class="self-service-section" data-testid="support-self-service-section">
      <div class="section-intro">
        <h2>Self-Service Resources</h2>
        <p>Get instant answers and learn how to use the platform at your own pace.</p>
      </div>

      <div class="resource-block" data-testid="support-copilot-block">
        <h3>Ask our Copilot Agent</h3>
        <p>Get real-time answers to your questions about using the portal.</p>
        <app-az-button
          data-testid="support-start-chatting-button"
          [label]="'Start Chatting'"
          [icon]="'chat'"
          (click)="onStartChatting()"
        ></app-az-button>
      </div>

      <div class="section-divider" role="presentation"></div>

      <div class="resource-block" data-testid="support-user-guide-block">
        <h3>User Guide</h3>
        <p>Download our comprehensive, step-by-step instructions.</p>
        <app-az-button
          data-testid="support-download-guide-button"
          [label]="'Download User Guide'"
          [icon]="'download'"
          (click)="onDownloadUserGuide()"
        ></app-az-button>
      </div>
    </div>

    <div class="help-desk-section" data-testid="support-help-desk-section">
      <div class="section-intro">
        <h2 data-testid="support-help-desk-heading">Help Desk Support</h2>
        <p>For general issues, bugs, or system errors, contact our central help desk.</p>
      </div>

      <p class="help-desk-contact">
        <strong>Email: </strong>
        <a
          class="email-link"
          data-testid="support-help-desk-email-link"
          [href]="'mailto:' + supportEmail"
          >{{ supportEmail }}</a
        >
        <br />
        <strong>Response Time: </strong>
        <span data-testid="support-help-desk-response-time">{{ helpDeskResponseTimeLabel }}</span>
      </p>
    </div>
  </section>
  <app-footer />
</div>
